import { useTranslation } from "react-i18next";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";

import { Avatar, DropdownActionListProps, DropdownActionsList, Flex } from "components";
import { useAuth } from "hooks";
import { ArrowBack, User } from "icons";
import { cssColor } from "utils";

export interface AccountDropdownProps extends Partial<DropdownActionListProps> {}

export const AccountDropdown = ({ ...props }: AccountDropdownProps) => {
  const { user, logout } = useAuth();
  const { t } = useTranslation("account");
  const navigate = useNavigate();

  const resolvedPath = useResolvedPath("account");
  const match = useMatch({
    path: resolvedPath.pathname,
    end: true,
  });

  return (
    <DropdownActionsList
      title={user?.full_name}
      logo={<Avatar fullName={user?.full_name} children={null} />}
      {...props}
    >
      <DropdownActionsList.Item selected={!!match} onClick={() => navigate("account")}>
        <Flex align="center" gap="0.4rem">
          <User width="1.4rem" height="1.4rem" /> <span>{t("account")}</span>
        </Flex>
      </DropdownActionsList.Item>
      <DropdownActionsList.Item onClick={logout}>
        <Flex align="center" gap="0.4rem" style={{ color: cssColor("danger-500") }}>
          <ArrowBack width="1.4rem" height="1.4rem" /> <span>{t("logout")}</span>
        </Flex>
      </DropdownActionsList.Item>
    </DropdownActionsList>
  );
};
